import React from 'react';

export const PageLayout = ({ children }) => {
  return (
    <div className="xl:container mx-auto flex h-full">
      <div className="w-4 lg:w-8 overflow-hidden border-l border-r border-[#ffd0c0] border-opacity-50 shrink-0 z-10">
        <div className="bg-[repeating-linear-gradient(-45deg,white,white_3px,white_0,#ffd0c0_4px)] h-full w-64" />
      </div>
      <div className="max-w-[calc(100%-32px)] lg:max-w-[calc(100%-64px)]">
        {children}
      </div>
      <div className="w-4 lg:w-8 overflow-hidden border-l border-r border-[#ffd0c0] border-opacity-50 shrink-0 z-10">
        <div className="bg-[repeating-linear-gradient(-45deg,white,white_3px,white_0,#ffd0c0_4px)] h-full w-64" />
      </div>
    </div>
  );
};
